import classNames from 'classnames';
import type { LinkInfo, Size } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import LinkButtonOrDiv from '../LinkButtonOrDiv';
import styles from './styles/styles.module.scss';

type CustomAvatarProps = {
  bordered?: boolean;
  children: React.ReactNode;
  className?: string;
  'data-denali'?: string;
  linkInfo?: LinkInfo;
  onClick?: () => void;
  size?: Size<'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'>;
  testId?: string;
  stopPropagation?: boolean;
};

// Used by the Avatar component and others to make an avatar-like component with arbitrary children
export default function CustomAvatar({
  bordered = false,
  children,
  className,
  'data-denali': dataDenali,
  linkInfo,
  onClick,
  size = 'md',
  testId,
  stopPropagation
}: CustomAvatarProps) {
  return (
    <LinkButtonOrDiv
      className={classNames(className, styles.customAvatar, styles[size], bordered && styles.bordered)}
      {...(dataDenali ? setDenaliAttribute(dataDenali) : {})}
      linkInfo={linkInfo}
      onClick={onClick}
      testId={testId}
      stopPropagation={stopPropagation}
    >
      {children}
    </LinkButtonOrDiv>
  );
}
